import type { ComponentType } from "react";
import BannerHint from "./BannerHint";
import EdgeHint from "./EdgeHint";
import KeycapHint from "./KeycapHint";
import type { DetonateHintVariantProps, HintInput } from "./types";

export type DetonateHintVariant = "keycap" | "banner" | "edge";

const variants: Record<DetonateHintVariant, ComponentType<DetonateHintVariantProps>> = {
  keycap: KeycapHint,
  banner: BannerHint,
  edge: EdgeHint,
};

export const detonateHintPatterns: Array<{ id: DetonateHintVariant; name: string; summary: string }> = [
  { id: "keycap", name: "A · Keycap", summary: "右上にキーキャップが浮かび、押せと脈打つ" },
  { id: "banner", name: "B · Banner", summary: "上部に爆発色のバナーで BLAST READY を告げる" },
  { id: "edge", name: "C · Edge", summary: "盤面のふちが爆発色に脈打ち、中央に大きく SPACE" },
];

export function defaultHintInput(): HintInput {
  return window.matchMedia("(pointer: coarse)").matches ? "touch" : "key";
}

/** Shown while a detonation-capable ball is in flight. Place inside a positioned playfield. */
export default function DetonateHint({ variant, input = defaultHintInput() }: { variant: DetonateHintVariant; input?: HintInput }) {
  const Variant = variants[variant];
  return <Variant input={input} />;
}
